import { render, staticRenderFns } from "./billing-details.vue?vue&type=template&id=4fa3ce01&scoped=true"
import script from "./billing-details.vue?vue&type=script&lang=js"
export * from "./billing-details.vue?vue&type=script&lang=js"
import style0 from "./billing-details.vue?vue&type=style&index=0&id=4fa3ce01&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa3ce01",
  null
  
)

export default component.exports